(() => {
  const productCardInit = () => {
    Alpine.data("lightningDealProgress", () => ({
      endTime: this.$el.dataset.ldEndTime,
      timeLeft: this.$el.dataset.ldTimeLeft,
      progress: this.$el.dataset.ldProgress,
      quantitySold: this.$el.dataset.ldQuantitySold,
      totalQuantity: this.$el.dataset.ldTotalQuantity,
      apiPath: this.$el.dataset.apiPath,
      selectedVariantId: "{{ product.selected_or_first_available_variant.id }}",
      uniqueId: "{{ product.id }}_" + Math.random().toString(36).substring(2, 10),

      expired: false,

      setUpLightningDeal() {
        if (this.timeLeft > 0 || this.progress < 100) {
          let interval = setInterval(() => {
            if (this.timeLeft > 0 && this.progress < 100) {
              this.timeLeft = this.endTime - Math.floor(Date.now() / 1000);
            } else {
              clearInterval(interval);
              this.expired = true;
            }
          }, 1000);
        } else {
          this.expired = true;
        }

        let evtSource = new EventSource(`https://cozy-earth-api.fly.dev/v1/lightning-deals/${apiPath}`);

        evtSource.addEventListener("purchase", (event) => {
          quantitySold += Number(event.data);
          progress = Math.min(((quantitySold * 100) / totalQuantity).toFixed(), 100);
        });
      },

      formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsRemaining = seconds % 60;
        return `${hours}:${String(minutes).padStart(2, "0")}:${String(secondsRemaining).padStart(2, "0")}`;
      },

      init() {
        if (this.$el.dataset.ldIsActive) {
          this.$watch("expired", (e) => {
            if (e) this.$refs.ldAttribute.remove();
          });
          this.setUpLightningDeal();
        }
      },
    }));

    Alpine.data("productCard", () => ({
      // Generate unique ID for this card instance
      uniqueId: Math.random().toString(36).substring(2, 10),
      // Will be set when color swatches are selected
      selectedVariantId: null,
      scrollPercentage: 0,

      onCardClick() {
        const breadcrumbTitle = this.$refs.productCardLink.dataset.breadcrumbTitle;
        const breadcrumbProduct = this.$refs.productCardLink.dataset.breadcrumbProduct;

        localStorage.setItem("breadcrumbUrl", window.location.pathname + window.location.search);
        localStorage.setItem("breadcrumbTitle", breadcrumbTitle);
        localStorage.setItem("breadcrumbProduct", breadcrumbProduct);

        const grid = document.querySelector("#collection-grid");
        if (grid) {
          localStorage.setItem("breadcrumbGrid", grid.innerHTML);
        }

        if (window.location.pathname.startsWith("/search")) {
          localStorage.setItem("breadcrumbSearch", window.location.href.split("#product-card")[0]);
        }
      },

      onImageScroll() {
        const imagesContainer = this.$refs.imagesContainer;
        const scrollWidth = imagesContainer.scrollWidth - imagesContainer.clientWidth;
        const currentScroll = imagesContainer.scrollLeft;
        const totalSlides = parseInt(imagesContainer.dataset.totalImages) || 1;

        if (scrollWidth > 0 && imagesContainer.dataset.isScrollable === "true") {
          this.scrollPercentage = ((currentScroll / scrollWidth) * (1 - 1 / totalSlides) + 1 / totalSlides) * 100;
        }
      },

      onImageClick() {
        this.$refs.productCardLink.click();
      },

      showImageScrollability() {
        const isTouchDevice = window.matchMedia("(hover: none) and (pointer: coarse)");
        const cardIndex = this.$el.dataset.cardIndex;

        if (isTouchDevice.matches && cardIndex === "0") {
          this.$refs.imagesContainer.style.scrollSnapType = "none";
          this.$refs.imagesContainer.scrollLeft = 0;
          setTimeout(() => {
            this.$refs.imagesContainer.scrollTo({ left: 100, behavior: "smooth" });
            this.onImageScroll();
            setTimeout(() => {
              this.$refs.imagesContainer.scrollTo({ left: 0, behavior: "smooth" });
              this.onImageScroll();
              this.$refs.imagesContainer.style.scrollSnapType = "";
            }, 200);
          }, 1000);
        }
      },

      init() {
        // Set initial variant ID to first available variant
        const firstVariantInput = this.$el.querySelector(".variant-selector");
        if (firstVariantInput) {
          const changeEvent = new Event("change");
          firstVariantInput.dispatchEvent(changeEvent);
        }
      },
    }));
  };
  if (window.Alpine) {
    productCardInit();
  } else {
    document.addEventListener("alpine:init", productCardInit, {
      once: true,
    });
  }
  window.__productCardScriptReady = true;
})();
